export default function ArticleSkeleton() {
  return (
    <div className="bg-white rounded-2xl overflow-hidden animate-pulse">
      <div className="px-5 pt-4 pb-0">
        <div className="h-3 w-28 bg-[#EDEAE6] rounded-full" />
      </div>
      <div className="mt-3 mx-4 rounded-xl overflow-hidden h-44 bg-[#EDEAE6]" />
      <div className="p-5 space-y-3">
        <div className="flex items-center gap-2">
          <div className="h-4 w-16 bg-[#EDEAE6] rounded-full" />
          <div className="h-3 w-20 bg-[#EDEAE6] rounded-full" />
        </div>
        <div className="h-4 w-full bg-[#EDEAE6] rounded-md" />
        <div className="h-4 w-4/5 bg-[#EDEAE6] rounded-md" />
        <div className="h-3 w-full bg-[#EDEAE6] rounded-md" />
        <div className="h-3 w-3/4 bg-[#EDEAE6] rounded-md" />
        <div className="flex gap-1.5 pt-1">
          <div className="h-5 w-14 bg-[#EDEAE6] rounded-md" />
          <div className="h-5 w-16 bg-[#EDEAE6] rounded-md" />
        </div>
        <div className="h-4 w-20 bg-[#EDEAE6] rounded-full" />
      </div>
    </div>
  );
}
